import { getQueryParam } from './query'
import { serverData } from './server-data'
import { logActivityWithLastImpression } from './fpti'
import { safeStringify } from 'universal'
import { WEBVIEW_CALLBACK_NAMES_BY_FLOWS } from 'universal/ucs'

const VeniceHandlerName = {
  home: 'home',
  close: 'close',
}

const LEGACY_WEBVIEW_CALLBACK_NAMES = {
  ON_ACTIVATION_SUCCESS_INIT: 'paypalCardActivationCompletionHandler',
}

const COMMON_WEBVIEW_CALLBACK_NAMES = {
  UCS_FLOW_ERROR: 'onUCSFlowError',
}

const WEBVIEW_CALLBACK_NAMES = {
  ...WEBVIEW_CALLBACK_NAMES_BY_FLOWS,
  ...COMMON_WEBVIEW_CALLBACK_NAMES,
}

function hasNativeWebviewQuerySignals(): boolean {
  const webview = getQueryParam('webview')
  if (webview && webview !== 'false') {
    return true
  }
  if (getQueryParam('webviewCallback')) {
    return true
  }
  const platform = String(getQueryParam('platform') || '').toLowerCase()
  return platform === 'ios' || platform === 'android'
}

function shouldTriggerVeniceCallback() {
  const webviewCallback = getQueryParam('webviewCallback')
  return isMobileNative() && !!webviewCallback
}

function triggerVeniceCallback(handlerName, webviewPayload) {
  const stringifiedPayload = webviewPayload ? safeStringify(webviewPayload) : ''

  const hasVeniceHandler = window.venice && window.venice[handlerName]
  const hasPaypalMobileHandler = window.paypalMobile && window.paypalMobile[handlerName]

  logActivityWithLastImpression(`veniceCallback:${handlerName}`, {
    message: `${stringifiedPayload}`,
    hasVeniceHandler,
    hasPaypalMobileHandler,
  })

  if (hasVeniceHandler) {
    if (stringifiedPayload) {
      window.venice[handlerName](stringifiedPayload)
      return true
    }
    window.venice[handlerName]()
    return true
  }

  if (hasPaypalMobileHandler) {
    if (stringifiedPayload) {
      window.paypalMobile[handlerName](stringifiedPayload)
      return true
    }
    window.paypalMobile[handlerName]()
    return true
  }

  return false
}

/**
 * Mirror server device.isMobileNative: Venice Android (PayPalQA) often opens enroll with
 * platform / webviewCallback but a sticky serverData.isMobileNative=false from an earlier
 * desktop-ish session. Prefer live query signals so ValueProp stays hidden and native
 * exits/callbacks still work when traffic briefly hits UCS.
 */
function isMobileNative() {
  // Tests often mock utils/server-data without isMobileNative; treat missing as web unless
  // the URL itself carries native webview signals.
  if (serverData?.isMobileNative) {
    return true
  }
  return hasNativeWebviewQuerySignals()
}

export {
  VeniceHandlerName,
  LEGACY_WEBVIEW_CALLBACK_NAMES,
  WEBVIEW_CALLBACK_NAMES,
  shouldTriggerVeniceCallback,
  triggerVeniceCallback,
  isMobileNative,
}
